<template>
  <div class="login-wrap">
    <p class="login-logo" id="enrollment">{{ $t('Enrollment.signUp') }}</p>
    <div class="login-form">
      <p class="enrollement-text">{{ $t('Enrollment.name') }}</p>
      <input
        type="text"
        :placeholder="$t('Enrollment.namePlaceholder')"
        @input="(event) => userInputDebounce('name', event)"
      />
    </div>
    <div class="login-form">
      <p class="enrollement-text">{{ $t('Enrollment.email') }}</p>
      <input type="text" @input="(event) => userInputDebounce('email', event)" />
    </div>
    <div class="login-form">
      <p class="enrollement-text">{{ $t('Enrollment.password') }}</p>
      <input
        type="password"
        :class="checkSameWithPassword"
        :placeholder="$t('Enrollment.pwPlaceholder')"
        @input="(event) => userInputDebounce('password', event)"
      />
    </div>
    <div class="login-form">
      <p class="enrollement-text">{{ $t('Enrollment.verifyPassword') }}</p>
      <input
        type="password"
        :class="checkSameWithPassword"
        @input="(event) => userInputDebounce('passwordAgain', event)"
      />
    </div>
    <div class="login-button">
      <button class="login-blue" @click="() => enrollment()">{{ $t('Enrollment.signUp') }}</button>
      <button class="login-lightblue" @click="() => moveLogin()">
        {{ $t('Enrollment.return') }}
      </button>
    </div>
  </div>
</template>

<script>
import { enroll } from '@/api/index';
export default {
  name: 'Enrollment',
  data() {
    return {
      name: '',
      email: '',
      password: '',
      passwordAgain: '',
      timer: null,
    };
  },
  methods: {
    userInputDebounce(part, event) {
      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        const value = event.target.value;
        switch (part) {
          case 'name':
            this.name = value;
            return;
          case 'email':
            this.email = value;
            return;
          case 'password':
            this.password = value;
            return;
          case 'passwordAgain':
            this.passwordAgain = value;
            return;
          default:
            return;
        }
      }, 200);
    },
    moveLogin() {
      this.$emit('controlMode');
    },
    checkName() {
      const nameRegExp = /^[가-힣]{2,7}$/;

      if (!this.name) return false;
      if (!nameRegExp.test(this.name)) return false;
      return true;
    },
    checkEmail() {
      const emailRegExp =
        /^[A-Za-z0-9_]+[A-Za-z0-9]*[@]{1}[A-Za-z0-9]+[A-Za-z0-9]*[.]{1}[A-Za-z]{1,3}[.]?[A-Za-z]{0,3}$/;

      if (!this.email) return false;
      if (!emailRegExp.test(this.email)) return false;
      return true;
    },
    checkPassWord() {
      const passWorddRegExp = /^[a-zA-Z0-9]{6, 16}$/;

      if (!this.password) return false;
      if (passWorddRegExp.test(this.password)) {
        return false;
      }
      return true;
    },

    enrollment() {
      if (!this.checkName()) {
        this.$emit(
          'showNotice',
          this.$i18n.locale === 'eng' ? 'Please enter a name.' : '이름을 입력해주세요.'
        );
      } else if (!this.checkEmail()) {
        this.$emit(
          'showNotice',
          this.$i18n.locale === 'eng' ? 'The email is invalid.' : '유효하지 않은 이메일입니다.'
        );
      } else if (this.password !== this.passwordAgain) {
        this.$emit(
          'showNotice',
          this.$i18n.locale === 'eng'
            ? `The passwords don't match.`
            : '비밀번호가 일치하지 않습니다.'
        );
      } else if (!this.checkPassWord()) {
        this.$emit(
          'showNotice',
          this.$i18n.locale === 'eng' ? 'The password is invalid.' : '비밀번호가 유효하지 않습니다.'
        );
      } else {
        enroll(this.email, this.password, this.name).then((response) => {
          this.$emit(
            'showNotice',
            this.$i18n.locale === 'eng'
              ? 'Your registration is complete.'
              : '회원가입이 완료되었습니다.'
          );
          this.$emit('controlMode');
        });
      }
    },
  },
  computed: {
    checkSameWithPassword() {
      if ((this.password === '') | (this.passwordAgain === '')) {
        return '';
      } else {
        return this.password === this.passwordAgain ? 'same' : 'notSame';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#enrollment {
  margin-bottom: 15px;
}

.notSame {
  background: #ffe2e2;
}
.same {
  background: #e3ffe1;
}

.enrollement-text {
  width: 100px;
}
</style>
